module.exports = __webpack_public_path__ + "static/media/german-numbers-1.f6d028ee.PNG";